module.exports = {
  API_BASE_URL: 'http://localhost:8000',
  MOCK_MODE: false,
  ENABLE_GTM: true,
  GTM_CONTAINER: 'GTM-NJRGT2C',
}
